import { IonIcon } from '@ionic/react';
import {
  chatbubbles,
  close,
  female,
  male,
  play,
  refresh,
  search,
  star,
  starHalf,
  starOutline,
  time,
  wallet,
} from 'ionicons/icons';
import React from 'react';

interface IconProps {
  icon: string;
}

const Icon = ({ icon }: IconProps) => <IonIcon icon={icon} />;

export const Close = (props: any) => <IonIcon icon={close} {...props} />;
export const ChatBubbles = (props: any) => (
  <IonIcon icon={chatbubbles} {...props} />
);
export const EmptyStar = (props: any) => (
  <IonIcon icon={starOutline} {...props} />
);
export const HalfStar = (props: any) => <IonIcon icon={starHalf} {...props} />;
export const Play = (props: any) => <IonIcon icon={play} {...props} />;
export const Star = (props: any) => <IonIcon icon={star} {...props} />;
export const Time = (props: any) => <IonIcon icon={time} {...props} />;
export const Wallet = (props: any) => <IonIcon icon={wallet} {...props} />;
export const Refresh = (props: any) => <IonIcon icon={refresh} {...props} />;
export const Male = (props: any) => <IonIcon icon={male} {...props} />;
export const Female = (props: any) => <IonIcon icon={female} {...props} />;
export const Search = (props: any) => <IonIcon icon={search} {...props} />;
